<template lang="pug">
  div.ml-3
    input#massUpload(
      type="file"
      ref="inputFile"
      name="file"
      @change="importData"
      class="sr-only"
    )
    div(class="mb-0")
      b-button.mr-2(variant="status-approved" size="sm" @click="openFileDialog(SHEMA_PROVIDER.INTERNAL)") Subir Plantilla Same Day
      b-button.ml-flex-btn(variant="status-approved" size="sm" @click="openFileDialog(SHEMA_PROVIDER.MERCADO_ENVIOS_FLEX)") Subir Plantilla Mercado Envíos Flex
</template>
<script>
import readXlsxFile from 'read-excel-file'
import { MERCADO_ENVIOS_FLEX_SHEMA, INTERNAL_SHEMA, SHEMA_PROVIDER, isFlexDelivery } from '@/utils/importPackagesUtils.js'
import * as Sentry from "@sentry/vue";

export default {
  props: ['communesOptions', 'services'],
  data() {
    return {
      SHEMA_PROVIDER,
      packages: [],
      provider: SHEMA_PROVIDER.INTERNAL,
      tagsNames: {
        FLEX: 'flex',
        CAMBIO: 'exchange',
        DEVOLUCIÓN: 'return'
      }
    }
  },
  methods: {
    getShema(provider) {
      switch (provider) {
        case SHEMA_PROVIDER.MERCADO_ENVIOS_FLEX:
          return MERCADO_ENVIOS_FLEX_SHEMA
        case SHEMA_PROVIDER.INTERNAL:
          return INTERNAL_SHEMA
        default:
          return INTERNAL_SHEMA
      }
    },
    openFileDialog(provider) {
      this.provider = provider
      this.$refs.inputFile.click()
    },
    normalizeShipmentsFromFlex(shipments) {
      return shipments.filter(isFlexDelivery).map(shipment => {
        return {
          customerName: shipment.customerName,
          customerAddress: shipment.customerAddress,
          commune: this.getCommune(shipment.customerCommune),
          labelCode: shipment.labelCode,
          saleId: shipment.saleId || null,
          tags: this.tagsNames.FLEX,
          size: 'small',
          bundleQuantity: 1,
          observations: '',
          customerPhone: '999999999',
          customerEmail: '',
          externalId: null,
          shippingCost: 0,
          isdisabled: true
        }
      })
    },
    normalizeShipmentsFromInternal(shipments) {
      return shipments.map(shipment => {
        return {
          withdrawalId: null,
          customerName: shipment.customerName !== undefined ? shipment.customerName : '',
          customerPhone: shipment.customerPhone !== undefined ? this.cleanPhone(shipment.customerPhone) : '',
          customerAddress: shipment.customerAddress !== undefined ? shipment.customerAddress : '',
          customerEmail: shipment.customerEmail !== undefined ? shipment.customerEmail : '',
          commune: shipment.customerCommune !== undefined ? this.getCommune(shipment.customerCommune) : null,
          bundleQuantity: shipment.bundleQuantity !== undefined ? parseInt(shipment.bundleQuantity) || 1 : 1,
          size: this.matchSize(shipment.size),
          tags: shipment.tags ? this.tagsNames[shipment.tags.toUpperCase()] : null,
          labelCode: (shipment.labelCode !== undefined ? shipment.labelCode : null) || (shipment.labelCode2 !== undefined ? shipment.labelCode2 : null),
          shippingCost: 0,
          observations: shipment.observations !== undefined ? shipment.observations : '',
          externalId: shipment.externalId !== undefined ? shipment.externalId : null,
          isdisabled: true
        }
      })
    },
    matchSize(size) {
      if (size === undefined || size === null) return null
      const sizeText = this.normalizeServiceText(size)
      if (!sizeText) return null
      if (sizeText === 'pequeno') return 'small'
      if (sizeText === 'mediano') return 'medium'
      const services = this.services || []
      const found = services.find(s => {
        if (!s || !s.name) return false
        return this.normalizeServiceText(s.name) === sizeText
      })
      return found ? found.name : null
    },
    normalizeServiceText(text) {
      if (!text) return ''
      let value = text.toString().toLowerCase()
      value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return value.replace(/[^a-z0-9]/g, '')
    },
    getNormalizeShipments(provider) {
      switch (provider) {
        case SHEMA_PROVIDER.MERCADO_ENVIOS_FLEX:
          return this.normalizeShipmentsFromFlex
        case SHEMA_PROVIDER.INTERNAL:
          return this.normalizeShipmentsFromInternal
        default:
          return this.normalizeShipmentsFromInternal
      }
    },
    getCommune(name) {
      const result = this.communesOptions.filter(commune => this.normalizeText(commune.text) === this.normalizeText(name))
      return result.length > 0 ? result[0].value : null
    },
    normalizeText(text) {
      if (!text) return ''
      text = text.toString().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return text.toLowerCase()
    },
    cleanPhone(phone) {
      // quitar espacios, signos de mas y caracteres no numericos y se queda con los ultimos 9 digitos
      if (!phone) return ''
      if (typeof phone !== 'string') phone = phone.toString()
      let phoneClean = phone.replace(/[^0-9]/g, '').replace(' ', '').replace('+', '')
      phoneClean = phoneClean.slice(-9)
      return phoneClean
    },
    getExcelConfig(provider) {
      const baseConfig = {
        trim: false,
      }
      switch (provider) {
        case SHEMA_PROVIDER.MERCADO_ENVIOS_FLEX:
          return {
            ...baseConfig,
            schema: MERCADO_ENVIOS_FLEX_SHEMA,
            sheet: 1,
            transformData(data) {
              const headerIndex = data.findIndex(r => r.includes('# de venta'))
              return data.slice(headerIndex)
            }
          }
        case SHEMA_PROVIDER.INTERNAL:
          return {
            ...baseConfig,
            schema: INTERNAL_SHEMA,
            sheet: 1,
          }
        default:
          return {
            ...baseConfig,
            schema: INTERNAL_SHEMA,
            sheet: 1,
          }
      }
    },
    async importData(e) {
      this.$emit('loading', true)
      try {
        const config = this.getExcelConfig(this.provider)
        const { rows } = await readXlsxFile(e.target.files[0], config)
        const packages = this.getNormalizeShipments(this.provider)(rows)
        if (this.provider === SHEMA_PROVIDER.MERCADO_ENVIOS_FLEX && !packages.length) {
          this.$root.$bvToast.toast('No se encontraron envíos con forma de entrega Mercado Envíos Flex', {
            title: 'Error',
            variant: 'danger'
          })
        } else {
          this.$emit('done', JSON.parse(JSON.stringify(packages)))
        }
      } catch (err) {
        Sentry.captureException(err)
        console.log({err})
      }
      this.$refs.inputFile.value = ''
      this.$emit('loading', false)
    }
  }
}
</script>

<style>
.ml-flex-btn {
  background-color: #ffe600;
  border-color: #ffe600;
  color: #2a3671;
}

.ml-flex-btn:hover {
  background-color: #d8c201;
  border-color: #d8c201;
  color: #2a3671;
}
</style>